import {StyleSheet} from 'react-native';
import {colors} from '../../constants';
import {MATERIAL_ICONS_FONT} from '../../styles/fonts';

const fc = colors.frame;

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: fc.background,
  },

  // Landscape layout - horizontal split
  landscapeContainer: {
    flex: 1,
    flexDirection: 'row',
  },
  landscapePhotoSection: {
    flex: 2, // 2/3 of screen
    overflow: 'hidden',
  },
  landscapeInfoSection: {
    flex: 1, // 1/3 of screen
    backgroundColor: fc.background,
    padding: 24,
    justifyContent: 'center',
  },

  // Portrait layout - vertical split
  portraitContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  portraitPhotoSection: {
    flex: 2, // 2/3 of screen
    overflow: 'hidden',
  },
  portraitInfoSection: {
    flex: 1, // 1/3 of screen
    backgroundColor: fc.background,
    padding: 20,
    justifyContent: 'center',
  },

  // Photo container
  photoContainer: {
    flex: 1,
    overflow: 'hidden',
  },
  photo: {
    // Size set dynamically
  },

  // DateTime section
  dateTimeSection: {
    marginBottom: 24,
  },
  greeting: {
    fontSize: 20,
    fontWeight: '600',
    color: fc.greeting,
    marginBottom: 8,
  },
  time: {
    fontSize: 48,
    fontWeight: '700',
    color: fc.primary,
    lineHeight: 52,
  },
  date: {
    fontSize: 18,
    fontWeight: '500',
    color: fc.text,
    opacity: 0.9,
    marginTop: 4,
  },

  // Portrait variants (smaller)
  portraitGreeting: {
    fontSize: 16,
    marginBottom: 4,
  },
  portraitTime: {
    fontSize: 36,
    lineHeight: 40,
  },
  portraitDate: {
    fontSize: 14,
  },

  // Reminders section
  remindersSection: {
    flex: 1,
  },
  remindersHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 12,
  },
  remindersIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 18,
    color: fc.primary,
  },
  remindersTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: fc.text,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  remindersList: {
    gap: 12,
  },
  reminderGroup: {
    gap: 6,
  },
  dayLabelContainer: {
    paddingVertical: 4,
    paddingHorizontal: 8,
    backgroundColor: fc.surfaceLight,
    borderRadius: 6,
    alignSelf: 'flex-start',
    marginBottom: 4,
  },
  dayLabelContainerToday: {
    backgroundColor: 'rgba(255, 158, 128, 0.2)',
  },
  dayLabel: {
    fontSize: 11,
    fontWeight: '700',
    color: fc.textMuted,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  dayLabelToday: {
    color: fc.primary,
  },
  reminderItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: fc.surfaceLight,
    borderRadius: 12,
    padding: 12,
  },
  reminderItemToday: {
    backgroundColor: 'rgba(255, 158, 128, 0.15)',
    borderLeftWidth: 3,
    borderLeftColor: fc.primary,
  },
  reminderTime: {
    fontSize: 12,
    fontWeight: '600',
    color: fc.textMuted,
    minWidth: 45,
  },
  reminderTimeToday: {
    color: fc.primary,
  },
  reminderTitle: {
    flex: 1,
    fontSize: 14,
    color: fc.text,
  },
  reminderTitleToday: {
    fontWeight: '600',
  },

  // Settings button
  settingsButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: 'rgba(41, 37, 36, 0.7)',
    backdropFilter: 'blur(12px)',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: fc.border,
    zIndex: 100,
  } as any,
  settingsIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 22,
    color: fc.text,
  },

  // Display name label
  displayNameLabel: {
    position: 'absolute',
    top: 16,
    left: 16,
    backgroundColor: 'rgba(41, 37, 36, 0.7)',
    backdropFilter: 'blur(12px)',
    paddingVertical: 8,
    paddingHorizontal: 14,
    borderRadius: 18,
    borderWidth: 1,
    borderColor: fc.border,
    zIndex: 100,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  } as any,
  displayNameIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 16,
    color: fc.primary,
  },
  displayNameText: {
    fontSize: 13,
    fontWeight: '600',
    color: fc.text,
  },

  // Reposition button
  repositionButton: {
    position: 'absolute',
    top: 16,
    right: 68,
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: 'rgba(41, 37, 36, 0.7)',
    backdropFilter: 'blur(12px)',
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: fc.border,
    zIndex: 100,
  } as any,

  // Edit mode
  editModeOverlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 80,
  },
  editModeBorder: {
    position: 'absolute',
    top: 4,
    left: 4,
    right: 4,
    bottom: 4,
    borderWidth: 3,
    borderColor: fc.primary,
    borderRadius: 12,
    borderStyle: 'dashed',
  } as any,
  editModeHeader: {
    position: 'absolute',
    top: 16,
    left: 0,
    right: 0,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 8,
    zIndex: 81,
  },
  editModeText: {
    backgroundColor: 'rgba(41, 37, 36, 0.9)',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 16,
    fontSize: 14,
    fontWeight: '600',
    color: fc.text,
    overflow: 'hidden',
  },
  editModeSaving: {
    backgroundColor: 'rgba(41, 37, 36, 0.9)',
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 12,
    fontSize: 12,
    color: fc.textMuted,
    overflow: 'hidden',
  },
  editModeSaved: {
    backgroundColor: 'rgba(34, 197, 94, 0.9)',
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 12,
    fontSize: 12,
    fontWeight: '600',
    color: '#fff',
    overflow: 'hidden',
  },
  editModeFooter: {
    position: 'absolute',
    bottom: 16,
    left: 0,
    right: 0,
    alignItems: 'center',
    zIndex: 81,
  },
  editModeDoneButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 24,
    backgroundColor: fc.primary,
  },
  editModeDoneIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 20,
    color: '#1c1917',
  },
  editModeDoneText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1c1917',
  },

  // Hint overlay
  hintOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 90,
  },
  hintContainer: {
    position: 'absolute',
    top: 12,
    right: 12,
    alignItems: 'flex-end',
  },
  hintArrow: {
    marginRight: 6,
    marginBottom: 2,
  },
  hintArrowIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 28,
    color: fc.primary,
  },
  hintBubble: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    backgroundColor: 'rgba(41, 37, 36, 0.95)',
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: fc.border,
    maxWidth: 260,
  } as any,
  hintIcon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 24,
    color: fc.primary,
  },
  hintContent: {
    flex: 1,
  },
  hintText: {
    fontSize: 14,
    fontWeight: '600',
    color: fc.text,
  },
  hintSubtext: {
    fontSize: 12,
    color: fc.textMuted,
    marginTop: 2,
  },
  hintButton: {
    marginTop: 10,
    backgroundColor: fc.primary,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 10,
    alignSelf: 'stretch',
  },
  hintButtonText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1c1917',
    textAlign: 'center',
  },

  // Loading progress
  loadingProgressContainer: {
    position: 'absolute',
    top: 16,
    left: 16,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    backgroundColor: 'rgba(41, 37, 36, 0.7)',
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 12,
    zIndex: 50,
  } as any,
  loadingProgressBar: {
    width: 50,
    height: 3,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: 2,
    overflow: 'hidden',
  },
  loadingProgressFill: {
    height: '100%',
    backgroundColor: fc.primary,
    borderRadius: 2,
  },
  loadingProgressText: {
    fontSize: 11,
    color: fc.textMuted,
    fontVariant: ['tabular-nums'],
  },

  // No reminders
  noReminders: {
    fontSize: 13,
    color: fc.textMuted,
    fontStyle: 'italic',
  },
});

export default styles;
